import { AllowedPanValues } from "./types";

/**
 * Converts alloewd pan values to a a web audio pan value
 */
export default function getPan(pan: AllowedPanValues): number {
  if (pan === "C") {
    return 0;
  }

  if (pan === "L") {
    return -1;
  }

  if (pan === "LC") {
    return -0.5;
  }

  if (pan === "R") {
    return 1;
  }

  if (pan === "RC") {
    return 0.5;
  }

  return 0;
}
